// extracted by mini-css-extract-plugin
export default {"backdrop":"MenuMobile_backdrop__f7Ylu","content":"MenuMobile_content__qMTOP","cancel":"MenuMobile_cancel__4issF"};